import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, GalleryHorizontal, Boxes, Scale, Link2, Image, Megaphone, Mail } from "lucide-react";
import { api } from "../../lib/api";

const CARDS = [
  { key: "users", label: "Usuarios", icon: Users, to: "/matriz/usuarios", url: "/admin/users" },
  { key: "banners", label: "Banners", icon: GalleryHorizontal, to: "/matriz/banners", url: "/admin/content/banners" },
  { key: "brands", label: "Marcas", icon: Boxes, to: "/matriz/ecosistema", url: "/admin/content/brands" },
  { key: "legal", label: "Docs legales", icon: Scale, to: "/matriz/legal", url: "/admin/legal/documents" },
  { key: "links", label: "Enlaces", icon: Link2, to: "/matriz/enlaces", url: "/admin/content/links" },
  { key: "media", label: "Multimedia", icon: Image, to: "/matriz/multimedia", url: "/admin/media" },
  { key: "announcements", label: "Comunicados", icon: Megaphone, to: "/matriz/intranet", url: "/admin/content/announcements" },
  { key: "messages", label: "Mensajes", icon: Mail, to: "/matriz", url: "/admin/contact-messages" },
];

export default function Dashboard() {
  const [counts, setCounts] = useState({});
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    CARDS.forEach((c) => {
      api.get(c.url).then((r) => {
        setCounts((prev) => ({ ...prev, [c.key]: r.data.length }));
        if (c.key === "messages") setMessages(r.data.slice(0, 5));
      }).catch(() => {});
    });
  }, []);

  return (
    <div data-testid="matriz-dashboard">
      <span className="font-mono-tech text-xs tracking-[0.3em] text-[#5698C7]">CENTRO DE CONTROL</span>
      <h1 className="font-display text-2xl font-light mt-2 mb-8">Panel MATRIZ</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {CARDS.map((c) => (
          <Link key={c.key} to={c.to} className="hud-border bg-white p-6 group" data-testid={`dashboard-card-${c.key}`}>
            <c.icon size={20} strokeWidth={1} className="text-[#5698C7] mb-4" />
            <div className="font-display text-2xl font-light">{counts[c.key] ?? "—"}</div>
            <div className="font-mono-tech text-[10px] tracking-widest text-slate-500 mt-1 group-hover:text-[#5698C7] transition-colors duration-200">{c.label.toUpperCase()}</div>
          </Link>
        ))}
      </div>
      <h2 className="font-display text-sm font-light mt-10 mb-4">Últimos mensajes de contacto</h2>
      <div className="border border-slate-200 rounded-lg bg-white shadow-sm">
        {messages.length === 0 && <p className="p-4 text-xs text-slate-400">Sin mensajes.</p>}
        {messages.map((m) => (
          <div key={m._id} className="border-b border-slate-100 last:border-0 p-4" data-testid={`message-${m._id}`}>
            <div className="flex justify-between">
              <span className="text-xs text-[#0B1220]">{m.name} <span className="text-slate-500">&lt;{m.email}&gt;</span></span>
              <span className="font-mono-tech text-[10px] text-slate-400">{m.created_at?.slice(0, 10)}</span>
            </div>
            {m.subject && <div className="text-xs text-[#5698C7] mt-1">{m.subject}</div>}
            <p className="text-xs text-slate-600 mt-1">{m.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
